import React from 'react';
// nodejs library that concatenates classes
import classNames from 'classnames';
// react components for routing our app without refresh
import { Link } from 'react-router-dom';
// core components
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
// core components
import Button from 'components/CustomButtons/Button.jsx';
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';

import sectionsStyle from 'assets/jss/material-kit-pro-react/views/presentationSections/sectionsStyle.jsx';

// images array used in rendering a function for this section
import imgs from 'assets/img/assets-for-demo/sections/imgs.jsx';
const youtubeLinks = [
  'https://www.youtube.com/embed/a2zIeW9NVjo',
  'https://www.youtube.com/embed/qhjrsRpkhv0',
  'https://www.youtube.com/embed/SnmbyIF0Zg8',
  'https://www.youtube.com/embed/gpuIQcsAKeU',
  'https://www.youtube.com/embed/zQI-9hNl9NQ',
  'https://www.youtube.com/embed/OFBRByqsKqQ',
  'https://www.youtube.com/embed/Wvc5CXXYlFQ',
  'https://www.youtube.com/embed/iRTjgNZhNJo',
  'https://www.youtube.com/embed/2DprmHm6jQ0',
  'https://www.youtube.com/embed/OFAi67GQbd8',
  'https://www.youtube.com/embed/Zb4Cfn6gzM4',
  'https://www.youtube.com/embed/TeMhglifF2U',
];

class SectionSections extends React.Component {
  renderContainerFluid(cssClass, classes) {
    return (
      <GridContainer>
        {youtubeLinks.map(link => {
          console.log(link);
          return (
            <GridItem
              md={3}
              sm={4}
              xs={12}
              key={Math.random()}
              className={cssClass}
            >
              <div>
                <div style={{ position: 'relative', paddingTop: '56.25%' }}>
                  <iframe
                    src={link}
                    frameBorder="0"
                    allowFullScreen
                    style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%',
                    }}
                  />
                </div>
              </div>
            </GridItem>
          );
        })}
      </GridContainer>
    );

    // return imgs.map(row => {
    //   return (
    //     <GridContainer key={row[0]}>
    //       {row.map((el, index) => {
    //         return (
    //           <GridItem
    //             md={3}
    //             sm={4}
    //             xs={12}
    //             key={`${el}_${index}`}
    //             className={cssClass}
    //           >
    //             <div>
    //               <div style={{ position: 'relative', paddingTop: '56.25%' }}>
    //                 <iframe
    //                   src="https://www.youtube.com/embed/nckseQJ1Nlg"
    //                   frameBorder="0"
    //                   allowFullScreen
    //                   style={{
    //                     position: 'absolute',
    //                     top: 0,
    //                     left: 0,
    //                     width: '100%',
    //                     height: '100%',
    //                   }}
    //                 />
    //               </div>
    //             </div>
    //           </GridItem>
    //         );
    //       })}
    //     </GridContainer>
    //   );
    // });
  }
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.sectionSections}>
        <div className={classes.container}>
          <GridContainer justify="center">
            <GridItem
              md={8}
              className={classNames(classes.mrAuto, classes.mlAuto)}
            >
              <div className={classes.sectionDescription}>
                <h2 id="programmes" className={classes.title}>
                  Programmes
                </h2>
                <h5 className={classes.description}>
                  Please enjoy the classes below
                </h5>
              </div>
            </GridItem>
          </GridContainer>
        </div>
        <div className={classes.containerFluid}>
          {this.renderContainerFluid(classes.photoGallery, classes)}
        </div>
      </div>
    );
  }
}

export default withStyles(sectionsStyle)(SectionSections);



// WEBPACK FOOTER //
// ./src/views/YogaPage/Sections/SectionSections.jsx